import React from 'react';
import * as styles from './CommentThreadCompact.module.scss';
import CommentThreadCompactAvatar from './CommentThreadCompactAvatar';
import CommentThreadCompactAvatarStack from './CommentThreadCompactAvatarStack';
import useAppSelector from '../../app/redux/useAppSelector';
import SVGIcon from '../../components/SVGIcon';
import { CREATION_ID } from '../../editor/editorSlice';
import { gql } from '../../graphql/generated/gql';
import commentIcon from '../../icons/non-prefilled/16x16/comment.svg';
import type { ExtractCommentThreadTypes } from '../../utils/post/threadUtils';
import { usePostLayoutSize } from '../../utils/responsive/PostLayoutSizeProvider';

const THREAD_FRAGMENT = gql(`
  fragment CommentThreadCompact_thread on RootThreadFields {
    id
    ... on CommentThread {
      comments {
        id
        author {
          id
          ...CommentThreadCompactAvatar_user
        }
      }
    }
    ... on PublicCommentThread {
      comments {
        id
        author {
          id
          ...CommentThreadCompactAvatar_user
        }
      }
    }
  }
`);

interface CommentThreadCompactProps {
  thread: ExtractCommentThreadTypes<typeof THREAD_FRAGMENT>;
}

const CommentThreadCompact = ({ thread }: CommentThreadCompactProps) => {
  const postLayoutSize = usePostLayoutSize();
  const canOnlyShowOne = postLayoutSize === 'mobile';
  const currentUser = useAppSelector((state) => state.session.user);

  const avatarStackItems =
    thread.id === CREATION_ID
      ? [{ id: currentUser.id, author: currentUser }]
      : thread.comments;

  if (postLayoutSize === 'tablet') {
    return (
      <SVGIcon size={16} className={styles.icon}>
        {commentIcon}
      </SVGIcon>
    );
  }

  const comments = canOnlyShowOne
    ? avatarStackItems.slice(0, 1)
    : avatarStackItems;

  return (
    <CommentThreadCompactAvatarStack items={comments}>
      {(item) => <CommentThreadCompactAvatar user={item.author} />}
    </CommentThreadCompactAvatarStack>
  );
};

export default CommentThreadCompact;
